var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.1,
    height: 24.105,
    viewBox: "0 0 24.1 24.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "globe-solid",
    d: "M16.353,15.387c-.7-4.34-2.367-7.387-4.3-7.387s-3.6,3.047-4.3,7.387ZM7.387,20.052a30.461,30.461,0,0,0,.16,3.11h9.005a30.461,30.461,0,0,0,.16-3.11,30.462,30.462,0,0,0-.16-3.11H7.547A30.461,30.461,0,0,0,7.387,20.052Zm15.78-4.665a12.078,12.078,0,0,0-7.679-6.882,16.4,16.4,0,0,1,2.43,6.882ZM8.612,8.505A12.07,12.07,0,0,0,.938,15.387H6.187A16.336,16.336,0,0,1,8.612,8.505Zm15.075,8.437H18.113c.1,1.021.16,2.065.16,3.11s-.058,2.09-.16,3.11h5.569a11.949,11.949,0,0,0,.418-3.11,12.157,12.157,0,0,0-.413-3.11ZM5.832,20.052c0-1.045.058-2.09.16-3.11H.418a11.782,11.782,0,0,0,0,6.221H5.987C5.89,22.142,5.832,21.1,5.832,20.052Zm1.92,4.665c.7,4.34,2.367,7.387,4.3,7.387s3.6-3.047,4.3-7.387ZM15.493,31.6a12.089,12.089,0,0,0,7.679-6.882H17.923A16.4,16.4,0,0,1,15.493,31.6ZM.938,24.718A12.078,12.078,0,0,0,8.617,31.6a16.4,16.4,0,0,1-2.43-6.882H.938Z",
    transform: "translate(0 -8)",
    fill: "#193062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.a6c22635387949c83af90cfea10b0b07.svg";
export { ForwardRef as ReactComponent };